export function ApproveInspectionCtrl (
  $scope,
  $translate,
  $uibModalInstance,
  inspection_id,
  items,
  messages,
  settings,
  workshopAPI
) {
  $scope.inspection_id = inspection_id;
  $scope.items         = items;
  $scope.settings      = settings;
  $scope.selectedItems = [];

  angular.forEach($scope.items, item => {
    if(item.needs_attention_soon) {
      item.urgency = $translate.instant('INSPECTIONS_SPACE.FIX_SOON');
    }
    else if (item.needs_attention_urgent) {
      item.urgency = $translate.instant('INSPECTIONS_SPACE.FIX_URGENTLY');
    }
  });

  $scope.buildColumns = function () {
    const columns = [
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.NAME')
        }
      }
    ];

    if (!$scope.settings.hide_estimated_hours) {
      columns.push({
        classes: 'text-right',
        field  : 'estimated_time',
        header : {
          classes: 'text-right',
          text   : $translate.instant('BOOKING_SPACE.ESTIMATED_HOURS')
        },
      });
    }

    if (!$scope.settings.hide_estimated_cost) {
      columns.push({
        classes: 'text-right',
        field  : 'estimated_cost',
        header : {
          classes: 'text-right',
          text   : $translate.instant('INSPECTIONS_SPACE.ESTIMATED_COST')
        },
        pipe: 'globalCurrency',
      });
    }

    columns.push({
      field : 'urgency',
      header: {
        text: $translate.instant('INSPECTIONS_SPACE.URGENCY')
      }
    });

    return columns;
  };

  $scope.tableSettings = {
    columns: $scope.buildColumns(),
    empty  : {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ITEMS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.confirm = function () {
    workshopAPI.post('/inspection/approve_work', {
      accepted_items: $scope.selectedItems.map(item => item.id),
      id            : $scope.inspection_id,
    })
    .then(response => {
      $uibModalInstance.close(response);
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.onRowClick = function () {
    $scope.selectedItems = $scope.items.filter((row) => row.selected);

    $scope.allSelected = ($scope.selectedItems.length == $scope.items.length);
  };

  $scope.toggleAll = function () {
    $scope.allSelected = !$scope.allSelected;

    angular.forEach($scope.items, function (invoice) {
      invoice.selected = $scope.allSelected;
    });

    $scope.selectedItems = $scope.items.filter((row) => row.selected);
  };
};